








































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ProjectMembers } from '@/@types/LibraryComponent.js';
import AccountIcon from '@/components/common/AccountIcon.vue';


@Component({
  components: {
    AccountIcon
  },
})
export default class AccountListTable extends Vue {
  @Prop({ required: true })
  private editMode = false;

  @Prop({ required: true })
  private projectMembers!: ProjectMembers[];

  @Emit('openLeaveMemberModal')
  private openLeaveMemberModal(projectMemberId: number, accountName: string) {
    return { projectMemberId, accountName };
  }

  private memberCardColor(deleteFlag: number): string {
    if (deleteFlag === 1) {
      return 'grey lighten-1';
    }
    return '';
  }
}
